export default {
    isAuthenticated (state) {
      return (!!state.token && !!state.userId)
    },
  }
  